const { default: Swiper } = require('swiper');
const { Autoplay } = require('swiper/modules');

const sections = document.querySelectorAll('section.tab-section');

if (sections.length) {
    sections.forEach(section => {
        const slider = section.querySelector('.slider');
        if (slider) {
            const slidesImages = section.querySelectorAll('[data-slide-image]');
            const swiper = new Swiper(slider, {
                direction: 'vertical',
                allowTouchMove: false,
                slideToClickedSlide: true,
                slideActiveClass: 'active',
                modules: [Autoplay],
                autoplay: {
                    disableOnInteraction: false,
                    waitForTransition: false,
                    delay: 6000,
                },
            });

            // setInterval(() => {
            //     if (!swiper.autoplay.running) {
            //         swiper.slideNext();
            //         swiper.autoplay.start();
            //     }
            // }, 6000);

            swiper.on('slideChange', e => {
                const { activeIndex } = e;
                slidesImages.forEach((slide, index) => {
                    if (index === activeIndex) {
                        setTimeout(() => {
                            slide.classList.add('active');
                        }, 300);
                    } else {
                        slide.classList.remove('active');
                    }
                });
            });
        }
    });
}
